import PropTypes from 'prop-types'
import React from 'react'
import Categories from './filters/Categories'
import CommodityCodes from './filters/CommodityCodes'
import Designations from './filters/Designations'
import { FilterResultsShape } from './prop_shapes/FilterResultsShape'
import MinRatings from './filters/MinRatings'

class SearchFilters extends React.Component {
  constructor (props) {
    super(props)
    this.state = this.defaultState()
  }

  defaultState = () => {
    if (this.props.locked) {
      return {
        designationsFilterClass: 'active',
        materialFilterClass: 'active',
        ratingFilterClass: 'active'
      }
    } else {
      return {
        designationsFilterClass: 'active',
        materialFilterClass: 'active',
        ratingFilterClass: ''
      }
    }
  }

  toggleFilterOptions = (filter) => {
    if (!this.props.locked) {
      const toggleClass = this.state[filter] === 'active' ? '' : 'active'

      this.setState({
        [filter]: toggleClass
      })
    }
  }

  categoryFilterCount = () => {
    if (this.props.category) {
      return this.props.categoryIds.filter(c => parseInt(c) !== parseInt(this.props.category.id))
    } else {
      return this.props.categoryIds.length
    }
  }

  renderClearBtn = (klass) => {
    const displayButton =
      this.props.designations.length > 0 ||
      this.props.minRating > 0 ||
      this.props.selectedCommodityCodeSegmentId ||
      this.props.selectedCommodityCodeSegmentTitle ||
      this.props.commodityCodes.length > 0 ||
      this.categoryFilterCount() > 0

    return (
      <a
        className={`button clear-all ${klass} ${displayButton ? '' : 'invisible'}`}
        onClick={this.props.onFilterClear}
      >
        Clear All <i className='fal fa-times' />
      </a>
    )
  }

  renderLock = () => {
    if (this.props.locked) {
      return (
        <>
          <i className='fas fa-lock' />
          &nbsp;
        </>
      )
    }
  }

  handleLockedClick = (event) => {
    this.props.onLockedClick(event, window.location.href)
  }

  renderAddSupplierButton = () => {
    if (!this.props.locked) {
      return (
        <a
          className='button large expanded add-supplier-btn'
          data-open='new-supplier-modal'
        >
          ADD A SUPPLIER
        </a>
      )
    }
  }

  render () {
    return (
      <>
        <div className='grid-x section'>
          <div className='cell auto'>
            {this.props.showCategories
              ? <Categories
                  categoryIds={this.props.categoryIds}
                  filterResults={this.props.filterResults}
                  showUnpublishedCategories={this.props.showUnpublishedCategories}
                  onCategoriesChange={this.props.onCategoriesChange}
                />
              : null}
          </div>
        </div>
        <div className='grid-x align-middle section filter-header'>
          <div className='auto cell'>
            <div className='filter-title'>Filters</div>
          </div>
          <div className='shrink cell'>
            {this.renderClearBtn('show-for-medium')}

            <i
              className='far fa-times fa-lg pointer-clickable mobile-close'
              onClick={this.props.onCloseMobileFilter}
            />
          </div>
          <div className='cell'>{this.renderClearBtn('show-for-small-only margin-top-1')}</div>
        </div>

        <div
          className={this.props.locked ? 'locked' : null}
          onClick={this.handleLockedClick}
        >
          <div
            className={`filter-category designations pointer-clickable ${this.state.designationsFilterClass}`}
          >
            <div
              className='grid-x'
              onClick={() =>
                this.toggleFilterOptions('designationsFilterClass')}
            >
              <div className='auto cell'>
                <h4>{this.renderLock()} Business Designation</h4>
              </div>
              <div className='shrink cell'>
                <i className='far open-toggle' />
              </div>
            </div>
            <div className='filter-options'>
              <Designations
                searchState={this.props.searchState}
                filterResults={this.props.filterResults}
                designations={this.props.designations}
                locked={this.props.locked}
                onDesignationsChange={this.props.onDesignationsChange}
              />
            </div>
          </div>

          <div
            className={`filter-category commodity-codes pointer-clickable ${this.state.materialFilterClass}`}
          >
            <div
              className='grid-x'
              onClick={() => this.toggleFilterOptions('materialFilterClass')}
            >
              <div className='auto cell'>
                <h4>{this.renderLock()} Product or Service Type</h4>
              </div>
              <div className='shrink cell'>
                <i className='far open-toggle' />
              </div>
            </div>
            <div className='filter-options'>
              <CommodityCodes
                commodityCodeSegments={this.props.filterResults.commodity_code_segments}
                activeCommodityFamilies={this.props.activeCommodityFamilies}
                commodityCodeFamilies={this.props.filterResults.commodity_code_families}
                onSegChange={this.props.onSegChange}
                onCommodityCodeChange={this.props.onCommodityCodeChange}
                onCommodityCodeSegmentChange={this.props.onCommodityCodeSegmentChange}
                selectedCommodityCodes={this.props.commodityCodes}
                commodityCodeFamilyCount={this.props.filterResults.commodity_code_family_count}
                commodityCodeSegmentCount={this.props.filterResults.commodity_code_segment_count}
                selectedCommodityCodeSegmentId={this.props.selectedCommodityCodeSegmentId}
                selectedCommodityCodeSegmentTitle={this.props.selectedCommodityCodeSegmentTitle}
                locked={this.props.locked}
              />
            </div>
          </div>

          <div className={`filter-category min-ratings pointer-clickable ${this.state.ratingFilterClass}`}>
            <div className='grid-x' onClick={() => this.toggleFilterOptions('ratingFilterClass')}>
              <div className='auto cell'>
                <h4>{this.renderLock()} Average Customer Review</h4>
              </div>
              <div className='shrink cell'>
                <i className='far open-toggle' />
              </div>
            </div>
            <MinRatings
              ratingCounts={this.props.filterResults.rating_counts}
              minRating={this.props.minRating}
              onMinRatingChange={this.props.onMinRatingChange}
              locked={this.props.locked}
            />
          </div>
        </div>

        {this.renderAddSupplierButton()}
      </>
    )
  }
}

SearchFilters.propTypes = {
  activeCommodityFamilies: PropTypes.array.isRequired,
  filterResults: FilterResultsShape,
  categoryIds: PropTypes.array.isRequired,
  designations: PropTypes.array.isRequired,
  seg: PropTypes.string,
  commodityCodes: PropTypes.array.isRequired,
  minRating: PropTypes.number.isRequired,
  onCategoriesChange: PropTypes.func.isRequired,
  onDesignationsChange: PropTypes.func.isRequired,
  onSegChange: PropTypes.func.isRequired,
  onCommodityCodeChange: PropTypes.func.isRequired,
  onCommodityCodeSegmentChange: PropTypes.func.isRequired,
  onMinRatingChange: PropTypes.func.isRequired,
  onFilterClear: PropTypes.func.isRequired,
  onCloseMobileFilter: PropTypes.func,
  searchState: PropTypes.string,
  selectedCommodityCodeSegmentId: PropTypes.number,
  selectedCommodityCodeSegmentTitle: PropTypes.string,
  locked: PropTypes.bool.isRequired,
  onLockedClick: PropTypes.func.isRequired,
  category: PropTypes.object,
  showCategories: PropTypes.bool,
  showUnpublishedCategories: PropTypes.bool
}

SearchFilters.defaultProps = {
  filterResults: {
    active_segment: {},
    active_designations: {},
    active_category_ids: {},
    all_categories: [],
    all_designations: [],
    commodity_code_families: [],
    commodity_code_family_count: {},
    commodity_code_segments: {},
    commodity_code_segment_count: {},
    designations_by_state: {},
    rating_counts: {}
  },
  seg: null,
  onCloseMobileFilter: null,
  searchState: null,
  selectedCommodityCodeSegmentId: null,
  selectedCommodityCodeSegmentTitle: null,
  category: null,
  showCategories: false,
  showUnpublishedCategories: false
}

export default SearchFilters
